import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1998122"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["colspan"]
const _hoisted_4 = { class: "pagination pagination-outline" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "page-link m-1 disabled"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" Tabela "),
    (_ctx.showTable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", {
            class: _normalizeClass(_ctx.tableClass)
          }, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: col.id || col.campo
                  }, _toDisplayString(col.topico || col.label), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.paginatedData.data.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                    _createElementVNode("td", {
                      colspan: _ctx.columns.length,
                      class: "text-center"
                    }, _toDisplayString(_ctx.noDataMessage), 9 /* TEXT, PROPS */, _hoisted_3)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.paginatedData.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: col.id || col.campo
                        }, _toDisplayString(_ctx.getCellValue(item, col)), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Paginação "),
    (_ctx.hasPages)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ 'card-footer': !_ctx.removeFooter })
        }, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item previous m-1", { disabled: _ctx.currentPage == 1 }])
            }, [
              _createElementVNode("span", {
                class: "page-link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
              }, [..._hoisted_6])
            ], 2 /* CLASS */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "page-item",
                key: page
              }, [
                (page !== '...')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      href: "#",
                      class: _normalizeClass(["page-link m-1", { active: page == _ctx.currentPage }]),
                      onClick: ($event: any) => (_ctx.goToPage(page))
                    }, _toDisplayString(page), 11 /* TEXT, CLASS, PROPS */, _hoisted_7))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, "..."))
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item next m-1", {
            disabled: _ctx.currentPage == _ctx.totalPages,
          }])
            }, [
              _createElementVNode("span", {
                class: "page-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
              }, [..._hoisted_10])
            ], 2 /* CLASS */)
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (_ctx.showBackButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({ ['card-footer mt-5']: _ctx.removeFooter })
        }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
          }, "Voltar")
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}